define([
    'jquery',
    'wcs.utils'
], function($, utils) {
    var defaults = {
        playedPercentEventMarks: [10, 25, 50, 75, 100]
    };

    function getEventData(event, options, isInteractive, $videoElement) {
        return {
            event: options.event,
            eventCategory: options.eventCategory,
            eventAction: options.eventAction,
            eventLabel: event,
            videoSource: $videoElement[0].currentSrc,
            videoPoster: $videoElement[0].poster,
            nonInteractive: !isInteractive
        };
    }

    function init(config) {
        var options = $.extend({}, defaults, config);

        if(WCS_CONFIG.get('ANALYTICS::gtmEnabled') && WCS_CONFIG.get('PDP::onsiteVideoEngagementTrackingEnabled')) {
            var $videoCollection = $(options.videoElementSelector);

            $videoCollection.each(function (idx) {
                var $videoElement = $(this);
                var $fullscreenElement = options.fullscreenElementSelector ? $(options.fullscreenElementSelector).eq(idx) : $videoElement;

                var videoParams = {
                    idx: idx,
                    $videoElement: $videoElement,
                    $fullscreenElement: $fullscreenElement,
                };

                trackVideoEvents(videoParams, options);
            });
        }
    }

    function trackVideoEvents(videoParams, options) {
        var playedPercentEventMarks = options.playedPercentEventMarks.slice();

        videoParams.$videoElement.on('play', function () {
            window.dataLayer.push(getEventData('Start Playing', options, true, videoParams.$videoElement));

            if (playedPercentEventMarks.length === 0) {
                playedPercentEventMarks = options.playedPercentEventMarks.slice();
            }
        });

        videoParams.$videoElement.on('pause', function (event) {
            if (event.currentTarget.currentTime !== event.currentTarget.duration) {
                window.dataLayer.push(getEventData('Pause', options, true, videoParams.$videoElement));
            }
        });

        videoParams.$fullscreenElement.on('webkitfullscreenchange mozfullscreenchange fullscreenchange', function () {
            var eventLabel = utils.getFullscreenElement() ? 'Full Screen On' : 'Full Screen Off';
            window.dataLayer.push(getEventData(eventLabel, options, true, videoParams.$videoElement));
        });

        videoParams.$videoElement.on('enterpictureinpicture', function () {
            window.dataLayer.push(getEventData('Picture in Picture Mode On', options, true, videoParams.$videoElement));
        });

        function triggerDownloadEvent() {
            window.dataLayer.push(getEventData('Video download', options, false, videoParams.$videoElement));
        }
        if (utils.getVideoBufferedTime(videoParams.$videoElement[0]) > 0) {
            triggerDownloadEvent();
        } else {
            videoParams.$videoElement.one('loadeddata', triggerDownloadEvent);
        }

        videoParams.$videoElement.on('timeupdate', function () {
            var playedPercent = Math.round(videoParams.$videoElement[0].currentTime / videoParams.$videoElement[0].duration * 100);

            while (playedPercentEventMarks.length && playedPercentEventMarks[0] <= playedPercent) {
                var eventLabel = 'Reached ' + playedPercentEventMarks.shift() + '%';
                window.dataLayer.push(getEventData(eventLabel, options, false, videoParams.$videoElement));
            }
        });
    }

    return {
        track: init,
    };
});
